import {
  Button,
  Group,
  Modal,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { Controller, useForm } from "react-hook-form"
import {
  CredentialType,
  Notification,
  NotificationMethod,
} from "../../../../models/notification.model"
import React from "react"
import { useCreateNotificationMutation } from "../store/notification.query"
import { useParams } from "react-router-dom"
import { IconDeviceFloppy } from "@tabler/icons-react"

const PushNotificationComponent = ({ open, opened, close }: any) => {
  const params = useParams()

  const defaultNotificationValue: Notification = {
    title: "",
    body: "",
    // type: CredentialType.Tenant,
    status: undefined,
    method: NotificationMethod.Sms,
  }
  let notificationSchema = yup
    .object()
    .shape({
      body: yup.string().typeError("Body should be string").required(),
      title: yup.string().typeError("Title should be string").required(),
      method: yup.string().typeError("Method  should be string").required(),
    })
    .required()

  const [createNotification, notificationResponse] =
    useCreateNotificationMutation()

  const {
    register: notificationRegister,
    setValue: notificationSetValue,
    control: notificationControl,
    handleSubmit: notificationHandleSubmit,
    reset: notificationReset,
    formState: { errors: notificationErrors },
  } = useForm({
    resolver: yupResolver(notificationSchema),
    mode: "onBlur",
  })

  const onNotificationSubmit = async (data: any) => {
    createNotification({
      ...data,
      receiver: params?.id,
      // type: CredentialType.Tenant,
    })
      .unwrap()
      .then((response) => {
        notificationReset(defaultNotificationValue)
        close()
        // setShowStatus(false);
        notificationReset(defaultNotificationValue)
      })
  }

  const onError = (error: any) => {
    console.log("🚀 ~ onError ~ error:", error)
  }

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          close()
          // setShowStatus(false);
          notificationReset(defaultNotificationValue)
        }}
        className="my-modal-content"
        withCloseButton={false}
        title="Notification"
        padding={20}
        size={"lg"}
      >
        <form
          onSubmit={notificationHandleSubmit(onNotificationSubmit, onError)}
          className={"mt-2"}
        >
          <div className="w-full">
            <div className="flex w-full space-x-4  justify-center">
              <Controller
                render={({ field }) => (
                  <Select
                    radius={"xs"}
                    classNames={{ label: "dark:text-white" }}
                    className="w-full"
                    error={
                      notificationErrors?.method &&
                      `${notificationErrors?.method?.message}`
                    }
                    label="Notification Method"
                    placeholder="Notification Method..."
                    // onSelect={(e) =>
                    //   e.currentTarget.value.toLowerCase() ==
                    //   CredentialType.Parent
                    //     ? setShowStatus(true)
                    //     : setShowStatus(false)
                    // }
                    data={[
                      { label: "Both", value: NotificationMethod.Both },
                      {
                          label: "Notification",
                          value: NotificationMethod.Notification,
                      },
                      { label: "Sms", value: NotificationMethod.Sms },
                    ]}
                    withAsterisk
                    {...field}
                  />
                )}
                name="method"
                control={notificationControl}
              />
              <TextInput
                classNames={{ label: "dark:text-white" }}
                className="w-full "
                error={
                  notificationErrors.title &&
                  `${notificationErrors?.title?.message}`
                }
                withAsterisk
                label="Title"
                placeholder="Title"
                {...notificationRegister("title")}
              />
            </div>

            <div className="flex w-full space-x-4  justify-center">
              <Textarea
                placeholder="Body..."
                label="Body"
                className="w-full"
                withAsterisk
                error={
                  notificationErrors?.body &&
                  `${notificationErrors?.body?.message}`
                }
                {...notificationRegister("body")}
              />
            </div>
          </div>
          <Group position="right" mt="xl">
            <>
              <Button
                classNames={{ label: "flex space-x-1 " }}
                variant="default"
                className="dark:text-white hover:bg-primary hover:dark:bg_dark_primary hover:text-white"
                type="reset"
                onClick={() => notificationReset(defaultNotificationValue)}
                size="xs"
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="fill-current h-6"
                    viewBox="0 0 32 32"
                  >
                    <path d="M18.90625 4.09375C18.101563 4.09375 17.265625 4.367188 16.625 4.9375L16.625 4.96875L16.59375 5L4.90625 16.59375C3.695313 17.804688 3.703125 19.777344 4.84375 21.0625L4.875 21.09375L4.90625 21.09375L10.90625 27.09375C11.511719 27.699219 12.320313 27.992188 13.125 28L28 28L28 26L16.5 26L27 15.5C28.265625 14.234375 28.304688 12.210938 27.09375 11L21.09375 5C20.488281 4.394531 19.710938 4.09375 18.90625 4.09375 Z M 18.875 6.125C19.195313 6.125 19.492188 6.210938 19.6875 6.40625L25.6875 12.40625C26.074219 12.792969 26.128906 13.558594 25.59375 14.09375L20.5625 19.125L12.90625 11.46875L17.96875 6.4375L18 6.40625C18.253906 6.195313 18.570313 6.125 18.875 6.125 Z M 11.46875 12.90625L19.125 20.5625L14.03125 25.65625C14.019531 25.664063 14.011719 25.679688 14 25.6875C13.484375 26.117188 12.691406 26.066406 12.3125 25.6875L6.34375 19.75C6.328125 19.730469 6.328125 19.707031 6.3125 19.6875C5.902344 19.171875 5.9375 18.375 6.3125 18Z" />
                  </svg>
                </span>
                <span>Reset</span>
              </Button>
              <Button
                variant="filled"
                className="bg-primary text-white"
                type="submit"
                classNames={{ label: "flex space-x-1" }}
                size={"xs"}
                loading={notificationResponse.isLoading}
              >
                <span>
                  <IconDeviceFloppy size={22} strokeWidth={1.5} />
                </span>
                <span>Submit</span>
              </Button>
            </>
          </Group>
        </form>
      </Modal>
    </>
  )
}

export default PushNotificationComponent
